export const common = {
  notFound: {
    title: "Page Not Found",
    subtitle: "Sorry, the page you visited does not exist or has been removed",
    description: "You can return to the homepage or try other pages",
    backHome: "Back to Home",
    goBack: "Go Back"
  },
  taskRecord: {
    participationYear: "Participation Year",
    selectYear: "Select Year",
    questionnaireName: "Questionnaire Name",
    taskNumber: "Task Number",
    returnTime: "Return Time",
    loadMore: "Load More",
    noMoreData: "No More Data~",
    noData: "No Data",
    status: "Status",
    exitedMidway: "Exited Midway",
    screenedOut: "Screened Out",
    quotaFull: "Quota Full",
    completedSuccessfully: "Completed Successfully",
    auditRejected: "Audit Rejected",
    qualityScreening: "Quality Screening"
  },
  taskDetails: {
    instantReward: "Instant Reward",
    unifiedReward: "Unified Reward"
  },
  task: {
    recommendedSurveys: "Recommended Surveys",
    topicDiscussion: "Topic Discussion",
    multipleCompletion: "Multiple Completion",
    participateNow: "Participate Now",
    noData: "No Data",
    hideConfirmTitle: "Notice",
    hideConfirmMessage: "If this survey indicates that you have participated or you are unwilling to participate, you can hide this project. After hiding, you will no longer be able to participate in this project. Please confirm whether to hide it?",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
    hideSuccess: "Hidden successfully"
  },
  reward: {
    completed: "Completed",
    screenedOut: "Screened Out",
    quotaFull: "Quota Full",
    successComplete: "Successfully Completed!",
    regretScreened: "Unfortunately, you have been screened out!",
    regretQuotaFull: "Unfortunately, the quota is full!",
    goldCoin: "Gold Coins",
    estimatedGold: "Estimated Gold Coins",
    completeTip1: "Based on your responses, you have completed all the questionnaires. Thank you for your active participation!",
    completeTip2: "Based on your responses, you have been screened out. Thank you for your active participation!",
    completeTip3: "Based on your responses, the quota is full. Thank you for your active participation!",
    auditTip: "Since this project uses 'Unified Reward' questionnaires, manual review is required before rewards are distributed. The estimated review time is 1-4 weeks. Please wait patiently.",
    moreRewards: "More Rewards Waiting for You",
    canExchange: "You can now redeem {giftName}!",
    needMoreCoins: "Need {coins} more gold coins to redeem {giftName}!",
    needMoreCoinsDefault: "Need 500 more gold coins to redeem {giftName}!",
    recommendForYou: "Recommended for You",
    moreSurveys: "More Surveys Waiting for Your Answers",
    increaseCredit: "Increase Credit Score",
    inviteFriends: "Invite Friends to Earn Gold Coins",
    goToAnswer: "Answer Now",
    goToRecommend: "Recommend Now",
    continueLightUp: "Continue to Light Up"
  },
  register: {
    smsCode: "SMS Verification Code",
    getCode: "Get Code",
    getAfterSeconds: "Get after {seconds}s",
    previousStep: "Previous Step"
  },
  redemptionHistory: {
    clickToClaim: "Click to Claim",
    claimed: "Claimed",
    loadMore: "Load More",
    noMoreData: "No More Data~",
    noData: "No Data",
    transactionTime: "Transaction Time",
    orderNumber: "Order Number",
    prizeName: "Prize Name",
    claimStatus: "Claim Status",
    pendingConfirmation: "Pending Confirmation",
    pendingReview: "Pending Review",
    reviewApproved: "Review Approved",
    reviewRejected: "Review Rejected",
    orderCancelled: "Order Cancelled",
    orderCompleted: "Order Completed"
  },
  notice: {
    messageTitle: "Message Title",
    readStatus: "Read Status",
    sendTime: "Send Time",
    messageContent: "Message Content",
    operation: "Operation",
    read: "Read",
    unread: "Unread",
    view: "View",
    delete: "Delete",
    messageDetail: "Message Details",
    close: "Close",
    loadMore: "Load More",
    noMoreData: "No More Data~",
    noData: "No Data"
  },
  latestNews: {
    latestAnnouncement: "Latest Announcement",
    home: "Home",
    allAnnouncements: "All Announcements",
    announcementDetail: "Announcement Details",
    previousArticle: "Previous Article",
    nextArticle: "Next Article",
    publishTime: "Publish Time",
    announcementTitle: "Announcement Title",
    operation: "Operation",
    viewDetail: "View Details",
    publishTimeLabel: "Publish Time: ",
    backToAllAnnouncements: "← Back to All Announcements",
    backToAnnouncements: "← All Announcements"
  }
};
